import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import LoadingButton from '@/components/functional/LoadingButton/LoadingButton.tsx';
import { PropsWithClassName } from '@/types/PropsWithClassName';
import { cn } from '@/utils/classNames.ts';

type StepFormActionsProps = PropsWithClassName<{
  onBack: () => void;
  continueLabel?: string;
  continueDisabled?: boolean;
  continueLoading?: boolean;
  onContinue?: () => void;
  submitType?: 'submit' | 'button';
  secondaryAction?: ReactNode;
}>;

const StepFormActions: FC<StepFormActionsProps> = ({
  onBack,
  continueLabel,
  continueDisabled,
  continueLoading = false,
  onContinue,
  submitType = 'submit',
  secondaryAction,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <div className={cn('flex flex-col gap-2 mt-auto', className)}>
      <LoadingButton
        loading={continueLoading}
        color="primary"
        className="w-full"
        type={submitType}
        disabled={continueDisabled}
        onClick={submitType === 'button' ? onContinue : undefined}
      >
        {continueLabel ?? t('button.continue')}
      </LoadingButton>
      {secondaryAction ?? (
        <button
          type="button"
          className="w-full py-2 px-[22px] h-[42px] bg-white border border-[rgba(0,0,0,0.12)] rounded-xl font-dm font-bold text-sm text-[#0F1B2A] tracking-[0.46px] transition-colors hover:bg-black/5"
          onClick={onBack}
        >
          {t('button.goBack')}
        </button>
      )}
    </div>
  );
};

export default StepFormActions;
